import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import img01 from './../assets/solutions_products/telecom.png'; // Adjust the path as necessary
import 'animate.css/animate.min.css'; // Import animate.css for animations



export default function Telecom() {
    return (
        <Container className='cybersecurity'>
            <h2 className="text-center title">Telecom Innovation Stack</h2>
            <Row>
                <div className='responsive-title'>Empowering Telcos to Go Beyond Connectivity</div>
            </Row>
            <Row className='mt-4'>
                <p className='text-center mb-4 content'>
                    We enable telecommunications to move beyond traditional infrastructure into a new era of smart, customer centric platforms. From mobile advertising and digital banking systems to real time usage control and value added services, we help telcos deliver faster, leaner, and more personalized experiences at scale.
                </p>
            </Row>

            <Row>
                <Col md={6} className='mb-4'>
                    <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.5} offset={100}>
                        <div className='hover-zoom bg-white'>
                            <img src={img01} alt="Telecom Innovation Stack" className='img-fluid' style={{ width: '100%', height: 'auto', borderRadius: '25px' }} />
                        </div>
                    </AnimationOnScroll>
                </Col>
                <Col md={6} className='mb-4'>
                    <AnimationOnScroll animateOnce={true} animateIn="- animate__flipInX" duration={.5} offset={100}>
                        <div className='mb-4 box'>
                            <div className='mb-4 box-title'>
                                What's In The Stack:
                            </div>

                            <Row>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Infrastructure as a Service (IaaS) & On-Premise Setup</h4>
                                    <p>Flexible IT foundations deploy anywhere, scale anytime, on your terms.</p>
                                </div>

                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Custom IT Development & Workflow Automation</h4>
                                    <p>Build smarter systems that automate the busywork and speed up execution.</p>
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>AI-Driven Command & Control Platforms</h4>
                                    <p>Centralized dashboards with intelligent insights to monitor, act, and optimize in real time.</p>
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Revenue Assurance & Fraud Management Systems</h4>
                                    <p>Minimize revenue leakage and detect anomalies before they become losses.</p>
                                </div>



                            </Row>
                        </div>
                    </AnimationOnScroll>
                </Col>

            </Row>


        </Container>
    )

}